import { CommonModule } from "@angular/common";
import { Component, OnDestroy, ViewChild, inject } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { IonContent, IonicModule, Platform } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

import { GlobalVarsModel } from "@models/ModelGlobalsVar";
import { BalancesService } from "@providers/BalancesService";
import { NewUserService } from "@providers/NewUserService";
import { TrackingService } from "@providers/TrackingService";
import { NewBaseService } from "@providers/newBase.service";
import { DeviceService } from "@services/device.service";

// components
import { CodereFooterComponent } from "@shared-mso-components/footer/codere-footer/codere-footer";
import { UserSectionTitle } from "@shared-mso-components/user-section-title/user-section-title";
import { EmptyState } from "@shared-payments-components/empty-state/empty-state";
import { MyBetTicketComponent } from "@sports-components/index";

//pipes
import { SportsExtractDatePipe, SportsFormatTitleEventPipe, SportsParseMoneyPipe } from "@sports-pipes/index";

// others
import { Utils } from "@sports-utils/Utils";
import { Subject, catchError, of, switchMap, takeUntil } from "rxjs";

@Component({
  selector: "mis-apuestas-presenciale-page",
  templateUrl: "mis-apuestas-presenciales.page.html",
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CodereFooterComponent,
    EmptyState,
    MyBetTicketComponent,
    SportsExtractDatePipe,
    UserSectionTitle,
    SportsFormatTitleEventPipe,
    SportsParseMoneyPipe,
  ],
  styleUrls: ["./mis-apuestas-presenciales.page.scss"],
})
export class MisApuestasPresencialesPage implements OnDestroy {
  @ViewChild(IonContent) content: IonContent;
  imageSource: string;
  form: { date: string; myType: string };
  arrTickets: any[];

  platform = inject(Platform);
  router = inject(Router);
  myParseMoney = inject(SportsParseMoneyPipe);
  translate = inject(TranslateService);
  utils = inject(Utils);
  newUserService = inject(NewUserService);
  trackingService = inject(TrackingService);
  balancesService = inject(BalancesService);
  deviceService = inject(DeviceService);
  newBaseService = inject(NewBaseService);
  globalVars: GlobalVarsModel;

  isMobile = false;
  isDesktop = false;

  private readonly unsubscribe$ = new Subject();

  constructor() {
    this.isDesktop = this.platform.is("desktop");
    this.imageSource = "assets/global/img/apuestas.svg";
    this.isDesktop = this.deviceService.isDesktop();
    this.isMobile = this.deviceService.isMobile();

    this.newBaseService.getVars
      .pipe(
        switchMap((data: GlobalVarsModel) => {
          this.globalVars = data;
          return of(null);
        }),
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe();

    //init form
    this.form = {
      date: "15",
      myType: "All",
    };

    this.getMyBets();
  }

  update() {
    this.getMyBets();
  }

  getMyBets() {
    const date = new Date();
    date.setDate(date.getDate() - parseInt(this.form.date));
    this.newUserService
      .getCardHistory(this.form.myType, date.toISOString())
      .pipe(
        takeUntil(this.unsubscribe$),
        catchError((_error) => {
          this.utils.showError(this.translate.instant("m_menu_serverFail"));
          return of([]); // Devuelve un array vacío en caso de error
        }),
      )
      .subscribe((data) => {
        this.content.scrollToTop();
        this.arrTickets = data;
      });
  }

  openBetDetail(ticketNumber: string, result: any) {
    this.router.navigate(
      [
        "BetDetailPage",
        { state: { params: { ticket: ticketNumber, betHistory: result, presenciales: true } } },
        { animate: !this.isDesktop },
      ],
      {},
    );
  }

  loadDetails(dateCard: any) {
    const ticket = dateCard.ticketNumber;
    const dateTicket = dateCard.dateTicket;
    this.newUserService.getTicketInfoCard(ticket).subscribe((data) => {
      if (data) {
        const currentDateTicket = this.arrTickets.findIndex((d) => d === dateTicket);
        const selectedTicket: any = this.arrTickets[currentDateTicket].betHistoryInfo.find(
          (t) => t.TicketNumber === ticket,
        );
        selectedTicket.betEvents = data.BetHistoryInfo.betEvents;
        selectedTicket.Status = data.Status;
        selectedTicket.StatusCode = data.StatusCode;
        selectedTicket.Amount = data.Amount;

        const newArrTickets = Object.assign([], this.arrTickets);
        this.arrTickets = newArrTickets;

        //Si aparece el bot�n "cobrar ahora" mandamos que la estad�stica, "Cerrar apuesta esta disponible".
        if (data.BetHistoryInfo.CashOutAmount !== 0 && data.BetHistoryInfo.TicketStatusNumber === "4") {
          this.trackingService.trackEvent([
            "EarlyCashOutAbility",
            "",
            "",
            "Cerrar apuesta disponible (EarlyCashOut)",
            "event",
          ]);
        } else if (data.BetHistoryInfo.CashOutAmount === 0 && data.BetHistoryInfo.TicketStatusNumber === "4") {
          // En el caso de que no se pueda cerrar la apuesta lanzamos la estad�stica, ""Cerrar apuesta no disponible", independientemente del estado de la apuesta (abierta, cerrada, cobrada...)
          this.trackingService.trackEvent([
            "EarlyCashOutNoAbility",
            "",
            "",
            "Cerrar apuesta no disponible (EarlyCashOut)",
            "event",
          ]);
        }
      }
    });
  }

  payOutTicket(params) {
    const ticketNr = params.ticketNumber;
    const amount = params.result.Amount;
    const msg =
      this.translate.instant("CloseBet1") +
      " " +
      this.myParseMoney.transform(parseInt(amount) / 100) +
      " " +
      this.translate.instant("CloseBet2") +
      "<br />" +
      this.translate.instant("compapuestaP3") +
      ":" +
      ticketNr;

    this.trackingService.trackEvent([
      "EarlyCashOutCallCodereCard",
      "",
      "",
      "Llamada a cerrar apuesta (EarlyCashOut)",
    ]);

    this.utils.confirm(
      true,
      this.translate.instant("CloseBet"),
      msg,
      this.translate.instant("tCancel"),
      null,
      this.translate.instant("tAccept"),
      () => {
        this.newUserService.payoutBetTicket(ticketNr, parseInt(amount), true).subscribe(
          (data) => {
            //La apuesta ha sido cerrada correctamente y se han agregado 1,24 a tu balance.

            if (data.success) {
              const msg2 =
                this.translate.instant("BetClose1") +
                " " +
                this.myParseMoney.transform(parseInt(amount) / 100) +
                " " +
                this.translate.instant("BetClose2");
              const title = this.translate.instant("CloseBet");
              this.utils.showMsg(
                msg2,
                () => {
                  this.globalVars.ticketStatusChanged = true;
                },
                title,
              );
              this.balancesService.refreshBalance();

              this.trackingService.trackEvent([
                "EarlyCashOutCompleteCodereCard",
                ticketNr,
                amount,
                "Cerrar apuesta completado  (EarlyCashOut)",
                "event",
              ]);
            } else {
              //error al cobrar
              const texto = data.status + " (" + data.statuscode + ")";

              this.utils.showError(texto, () => {});

              this.trackingService.trackEvent([
                "EarlyCashOutFailureCodereCard",
                ticketNr,
                amount,
                "Cerrar apuesta fallido (EarlyCashOut)",
                "event",
              ]);
            }
          },
          () => {
            this.utils.showError("", () => {});
          },
        );
      },
    );
  }

  getEarlyCashoutEnabled(): boolean {
    return this.newUserService.getEarlyCashoutEnabled();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
